import React from "react";

const TripleDotIcon = ({ color = "#000", size = 20 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0001 4.16664C11.1507 4.16664 12.0834 3.23391 12.0834 2.08332C12.0834 0.932734 11.1507 0 10.0001 0C8.84948 0 7.91675 0.932734 7.91675 2.08332C7.91675 3.23391 8.84948 4.16664 10.0001 4.16664Z"
        fill={color}
        fillOpacity="0.8"
      />
      <path
        d="M10.0001 12.0834C11.1507 12.0834 12.0834 11.1507 12.0834 10.0001C12.0834 8.84948 11.1507 7.91675 10.0001 7.91675C8.84948 7.91675 7.91675 8.84948 7.91675 10.0001C7.91675 11.1507 8.84948 12.0834 10.0001 12.0834Z"
        fill={color}
        fillOpacity="0.8"
      />
      <path
        d="M10.0001 19.9999C11.1507 19.9999 12.0834 19.0672 12.0834 17.9166C12.0834 16.766 11.1507 15.8333 10.0001 15.8333C8.84948 15.8333 7.91675 16.766 7.91675 17.9166C7.91675 19.0672 8.84948 19.9999 10.0001 19.9999Z"
        fill={color}
        fillOpacity="0.8"
      />
    </svg>
  );
};

export default TripleDotIcon;
